import { Button as AntdButton } from "antd";

import React from "react";

const Button = (props) => {
  return <AntdButton {...props} />;
};

export default React.memo(Button);
